// extracted by mini-css-extract-plugin
export default {"contextMenuButtonSeparator":"ElementContextMenu__contextMenuButtonSeparator___ptCYf"};